import { memo, useMemo } from 'react';
import type { SamplingTaskCardProps } from './sampling-task-card.types.ts';
import { SamplingTaskCard } from './sampling-task-card.tsx';
import type { SamplingJob } from '../../services/api.types.ts';
import { Label } from '@progress/kendo-react-labels';
import { formatDate } from '@progress/kendo-intl';

export const SamplingStatusTaskCard = memo(
  function SamplingStatusTaskCard(props: SamplingTaskCardProps) {
    const formattedDates = useMemo(
      () => ({
        planned: props.data.plannedDate ? formatDate(new Date(props.data.plannedDate), 'dd MMM yyyy') : '-',
      }),
      [props.data.plannedDate]
    );

    return (
      <SamplingTaskCard {...props}>
        <Label>Company:</Label>
        <span>{props.data.companyTitle}</span>
        <Label>Job No:</Label>
        <span>SSJ{props.data.id}</span>
        <Label>Planned Date:</Label>
        {formattedDates.planned}
      </SamplingTaskCard>
    );
  },
  (prev, next) => {
    const prevJob = prev.data as unknown as SamplingJob;
    const nextJob = next.data as unknown as SamplingJob;

    return prev.data.id === next.data.id && prev.isOverlay === next.isOverlay && prevJob === nextJob;
  }
);
